import React from 'react';
import { Button, Space, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import SelectableListButton from '../SelectableListButton';

const builtInGroups = [
  ['general_soap', 'first_visit', 'encounter_summary'],
  ['psychotherapy', 'psychiatric_evaluation'],
  ['specialist_visit', 'ob_gyn_visit', 'pediatric_visit', 'surgical_follow_up'],
  ['hospital_progress_note', 'emergency_urgent_care'],
  ['nutrition_consultation']
];

const { useBreakpoint } = Grid;

export default function NoteTypeBuiltInTab({ noteTypes, selectedNoteTypeSlug, onSelectNoteType, detailsPage, onCancelClick }) {
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const renderButtons = (data, slugs) => (
    slugs.map((slug) =>
      data.filter((type) => type.slug === slug).map((type) => (
        <SelectableListButton
          key={type.slug}
          title={t(`note_type_selector.note_types.${type.slug}.title`)}
          subtitle={t(`note_type_selector.note_types.${type.slug}.description`)}
          onClick={() => onSelectNoteType(type.slug)}
          isSelected={!screens.xs && selectedNoteTypeSlug === type.slug}
          testId={`note-type-button-${type.slug}`}
        />
      ))
    )
  );

  return (
    <div style={{ 
      width: '100%', 
      maxHeight: '600px',
      overflowY: 'auto', 
      padding: '15px 0',
      paddingRight: '8px'
    }}>
      <Space direction="vertical" style={{ width: '100%', display: 'flex' }}>
        {builtInGroups.map((group, index) => (
          <React.Fragment key={index}>
            <div style={{ width: '100%' }}>
              {renderButtons(noteTypes, group)}
            </div>
            <div style={{ width: '100%', height: '20px' }}></div>
          </React.Fragment>
        ))}
        <div style={{ width: '100%' }}>
          {!detailsPage && (
            <Button
              block
              danger
              onClick={onCancelClick}
              data-testid="note-type-button-cancel"
            >
              {t('note_type_selector.delete')}
            </Button>
          )}
        </div>
      </Space>
    </div>
  );
}


